import { IsOptional, IsBoolean } from 'class-validator';

export class CreateCashTransactionGroupTransactionResultDto {
  @IsOptional()
  @IsBoolean()
  success?: boolean;
}
